module.exports = __webpack_public_path__ + "assets/images/user-background.png";